function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Bulb = function Bulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    d: "M14.004 21.187a.75.75 0 0 1 0 1.5H9.996a.75.75 0 0 1 0-1.5zM12 1.313a7.64 7.64 0 0 1 4.87 13.528c-.434.358-.675.806-.675 1.234v2.506c0 .896-.726 1.623-1.623 1.623H9.43a1.623 1.623 0 0 1-1.623-1.623v-2.506c0-.428-.243-.876-.675-1.234A7.64 7.64 0 0 1 12 1.314M9.306 18.581c0 .068.055.123.123.123h5.143a.123.123 0 0 0 .123-.123v-1.025h-5.39zM12 2.813a6.14 6.14 0 0 0-3.912 10.872c.663.55 1.21 1.38 1.217 2.37h5.391c.007-.99.554-1.82 1.217-2.37A6.14 6.14 0 0 0 12 2.813m.23 1.43A4.667 4.667 0 0 1 16.665 8.9a.75.75 0 0 1-1.5 0 3.165 3.165 0 0 0-3.01-3.16L12 5.735l-.077-.004A.75.75 0 0 1 12 4.236z"
  }));
};
export default Bulb;
Bulb.displayName = 'Bulb';